import '../../../styles/index.css'
import './BotaoRemover.css';
import MinusIconWhite from '../../../assets/icons/Minus Icon.svg';

function BotaoRemover({onClick}) {

    return (

        <button className='botaoRemover' onClick={onClick} data-cy="botao-remover-trigger">
            <img src={MinusIconWhite} alt="" />
            <span className='bt2'>Remover</span>
        </button>

    );
}

export default BotaoRemover;
